import type { Zoom } from "../../lib/periods.ts";
import { cn } from "../../lib/utils.ts";
import { Button } from "../ui/button.tsx";

const ZOOMS: { key: Zoom; label: string }[] = [
  { key: "days", label: "Days" },
  { key: "weeks", label: "Weeks" },
  { key: "months", label: "Months" },
];

/**
 * What one bar of the Trends charts covers: a day (the last two weeks), a
 * week of life, or a month of life. Chips, the app's pick-one-value control,
 * so they read apart from the ink chart tabs under them.
 */
export function ZoomChips({ zoom, onSelect }: { zoom: Zoom; onSelect: (zoom: Zoom) => void }) {
  return (
    <div role="group" aria-label="Show trends by" className="mt-4 flex max-w-[22rem] gap-2">
      {ZOOMS.map((z) => (
        <Button
          key={z.key}
          variant="chip"
          className={cn(zoom === z.key && "is-selected")}
          aria-pressed={zoom === z.key}
          onClick={() => onSelect(z.key)}
        >
          {z.label}
        </Button>
      ))}
    </div>
  );
}
